import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { AppState } from 'app/core/reducers';
import { UserRequested } from 'app/core/auth/_actions/auth.actions';
import { isUserLoaded } from 'app/core/auth/_selectors/auth.selectors';
import { BAMessageRedirectService } from 'app/core/o2c/inquiries/_services/ba-message-redirect.service';
import { environment } from 'environments/environment';
import { filter, take, timeout } from 'rxjs/operators';

/**
 * Landing page after Duo authentication. Waits for user to be loaded from token/cookie,
 * then redirects to Message Search (if BA with pending messages) or dashboard.
 */
@Component({
  standalone: false,
	selector: 'kt-login-callback',
	templateUrl: './login-callback.component.html',
})
export class LoginCallbackComponent implements OnInit {

	constructor(
		private router: Router,
		private store: Store<AppState>,
		private baMessageRedirect: BAMessageRedirectService
	) { }

	ngOnInit(): void {
		const token = localStorage.getItem(environment.authTokenKey);
		if (!token) {
			this.router.navigateByUrl('/auth/login');
			return;
		}
		this.store.dispatch(new UserRequested());
		this.store.pipe(
			select(isUserLoaded),
			filter(loaded => loaded === true),
			take(1),
			timeout(12000)
		).subscribe({
			next: () => {
				this.baMessageRedirect.redirectToMessageSearchIfNeeded('/dashboard/dashboard').subscribe();
			},
			error: () => {
				this.router.navigateByUrl('/auth/login');
			}
		});
	}

}
